import VBottomSheet from './VBottomSheet'

VBottomSheet.install = function install (Vue) {
  Vue.component(VBottomSheet.name, VBottomSheet)
}

export default VBottomSheet



// WEBPACK FOOTER //
// ./src/components/VBottomSheet/index.js